import { Router } from '@angular/router';
import { TokenStorageService } from './../../../../auth/helpers/token-storage.service';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, OnChanges, SimpleChanges, ViewChild, Input } from '@angular/core';

import { DataServiceService } from 'app/service/data-service.service';
import { ApiService } from 'app/auth/helpers/apiservice';
import { ToastrService } from 'ngx-toastr';
import { CoreConfigService } from '@core/services/config.service';
import { ModalSpinnerComponent } from 'app/main/pages/modal-spinner/modal-spinner.component';
import { timerRedo } from 'app/utils/timer';
import { NotifserviceService } from 'app/service/notifservice.service';
import { ToastService } from 'app/service/toast.service';



@Component({
  selector: 'app-navbar-notification',
  templateUrl: './navbar-notification.component.html'
})
export class NavbarNotificationComponent implements OnChanges {
  @Input() hiddenMenu;config :any; affButton = false;
  public notifications: any; getdata = true;
  nbr:any = '0';
  @ViewChild(NgbDropdown) drop:NgbDropdown;

  /**
   *
   * @param {NotificationsService} _notificationsService
   */
  constructor(private dataservice: DataServiceService, private ApiSrv: ApiService,private token:TokenStorageService,
    private toastr : ToastService,private _router: Router, private _config: CoreConfigService, private modal: NgbModal,
    private notifservice: NotifserviceService) {
    this.notifservice.data$.subscribe((d) => {
      this.getNotificationsData();
    }); 
    this.dataservice.data$.subscribe((d) => {this.nbr = d.unviewedNotifications});   
    setTimeout(() => {
      this.config = this._config.getConfig();
      this.config.subscribe(x => this.hiddenMenu = x.layout.menu.hidden === true);
      this.getNotificationsData();
    }, 2000);
    
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data){
      this.nbr = changes.data.currentValue;
    }
  }

  getNotificationsData() {
    let user = JSON.parse(localStorage.getItem("currentUser"));
    if (!this.hiddenMenu && user != null ){
      const data = {
        schema_webservice: '/notification/getMyNotifications'
      };
  
      this.ApiSrv.api(data).subscribe((res) => {
        if (res.code === '00') {
          this.nbr = res.unviewedNotifications;
          this.getdata = false;
          this.notifications = res.notifications;
          if (this.notifications.length>0) {
            this.affButton = true;
          }
        } else if (res.code === '01') {
          this.toastr.error(res.message);
        }else if (res.code === '08') {
          const modalRef = this.modal.open(ModalSpinnerComponent, { centered: true,backdrop: "static", windowClass:'custommodal' });
          setTimeout(() => {
            modalRef.dismiss();
            this.getNotificationsData();
          }, timerRedo);
        }
      });
    }    
  }

  navNotif() {
    if (this.nbr === 0) {
      this._router.navigate(['/pages/notifications']);
    }else{
      const data = {
        schema_webservice: '/notification/updateAll'
      };
  
      this.ApiSrv.api(data).subscribe((res) => {
        if (res.code === '00') {
          this.nbr = '0';
          this.drop.close();
        }
        this._router.navigate(['/pages/notifications']);
      });
    }
    
  }

}
